if (!customElements.get('cart-gift')) {
  class CartGift extends HTMLElement {
    constructor() {
      super();
      this.querySelector('input').addEventListener('change', this.updateCart.bind(this));
    }

    async updateCart(event) {
      const isChecked = event.target.checked;
      const line = this.dataset.itemLine;

      // all line item properties are always removed when you update, so get the current one

      const response = await fetch(`${theme.routes.cart}.js`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const cart = await response.json();
      const cartItem = cart.items[line - 1];
      let properties = cartItem.properties;

      if (isChecked) {
        // if item is checked, add it to the line item properties
        properties['Inpakken'] = 'Ja';
      }
      else {
        // when items is unchecked, remove the property altogether
        delete properties['Inpakken'];
      }

      //then update the line item
      const body = {
        line,
        properties,
      };

      fetch('/cart/change.js', {
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(async (response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
        })
        .catch((error) => {
        // eslint-disable-next-line no-console
          console.log(error.message);
          this.dispatchEvent(new CustomEvent('on:cart:error', {
            bubbles: true,
            detail: {
              error: error.message,
            },
          }));
          // Uncertainty... Reload page.
          window.location.reload();
        });
    }
  }
  customElements.define('cart-gift', CartGift);
}
